import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import React, {useEffect} from "react";
import Table from "../../components/common/table/Table";
import {useDispatch, useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {
    deleteTransaction,
    fetchAllTransaction,
    resetCreateStatus,
    resetUpdateStatus
} from "../../store/transaction-slice";
import {getTableColumns, getTableData} from "../../models/transactionModel";
import ActionDropdown from "../../components/actions/ActionDropdown";
import {fetchNotApplicableList} from "../../store/list-slice";

const TransactionView = () => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    const {
        items,
        fetchStatus,
        createStatus,
        updateStatus,
        pagination,
        error
    } = useSelector(state => state.transaction);

    const list = useSelector(state => state.list);
    const userRole = useSelector((state) => state.auth.selectedRole);
    //set initial page and limit
    const initialPage = Number(searchParams.get("page")) || 1;
    const initialLimit = Number(searchParams.get("limit")) || 25;

    useEffect(() => {
        dispatch(fetchAllTransaction({
            ...userRole,
            page: initialPage,
            limit: initialLimit
        }));
    }, [dispatch, userRole, initialPage, initialLimit]);

    useEffect(() => {
        dispatch(fetchNotApplicableList())
    }, [dispatch]);

    useEffect(() => {
        if (createStatus === "success") {
            dispatch(resetCreateStatus());
        }
    }, [dispatch, createStatus]);

    useEffect(() => {
        if (updateStatus === "success") {
            dispatch(resetUpdateStatus());
        }
    }, [dispatch, updateStatus]);

    const deleteHandler = (id) => {
        dispatch(deleteTransaction({...userRole, id: id}));
    };

    const tableColumns = getTableColumns({ActionDropdown, deleteHandler});
    const tableData = getTableData({items, list});

    return (
        <>
            <SubHeader title="All Transactions">
                <Button to="add" className="btn-sm bg-primary bg-opacity-50">Add New</Button>
            </SubHeader>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <Table
                    className="mobile-responsive"
                    columns={tableColumns}
                    data={tableData}
                    pagination={pagination}
                />
            )}
        </>
    )
}

export default TransactionView;